const Separator = () => {
  return <div className="w-px h-7 md:h-9 bg-light-800"></div>;
};

export { Separator };
